export enum ApplicantType {
  PRIMARY = 'PRIMARY',
  GUARANTOR = 'GUARANTOR',
  COSIGNER = 'COSIGNER',
}
